<template>
  <div class="wrapper-load">
    <slot/>
    <div v-show="loading"
         class="overlay">
      <div class="loop-wrapper">
        <div class="rock"></div>
        <div class="truck">
          <img class="surfer"
               width="47"
               :src="require(`@/assets/img/tablista${Math.floor(Math.random() * 2) !== 0 ?
              '_snowboard' : '_congelado'  }.png`)">
          <img class="logo" :src="require('@/assets/img/logoTruck_mini.png')">
          <svg width="120" height="75" viewBox="0 0 85 60">
            <!--eslint-disable-next-line -->
            <path fill="#AAD500" d="M5.138 54.039a3.77 3.77 0 0 1-.149-.005l-.859.002A4.134 4.134 0 0 1 0 49.906V5.195a4.135 4.135 0 0 1 4.13-4.133h46.973c2.272 0 4.123 1.95 4.123 4.229v44.612a4.133 4.133 0 0 1-4.127 4.131H29.962c-1.091-.019-3.239-.691-3.727-3.128-1.067-3.957-4.755-6.789-8.947-6.789-4.291 0-8.098 3.041-9.051 7.229-.225 1.817-1.723 2.693-3.099 2.693zM4.127 4.208c-.596 0-1.083.389-1.083.987v44.709c0 .597.488 1.086 1.086 1.086h1.004c.005-.047.123-.271.133-.317 1.267-5.562 6.323-9.597 12.022-9.597a12.356 12.356 0 0 1 11.912 9.137c.151.734.681.777.785.777h21.111c.596 0 1.083-.487 1.083-1.084V5.293c0-.598-.485-1.085-1.083-1.085H4.127zM84.929 35.828s-.093-2.093-.288-3.118c-.164-.873-1.087-2.644-1.087-2.644l-7.299-13.59c-.951-1.52-3.115-2.707-4.558-2.707H60.785a2.608 2.608 0 0 0-2.606 2.609v33.526a2.609 2.609 0 0 0 2.606 2.609h.643s.949-.123 1.304-1.312c.986-3.933 4.514-6.862 8.749-6.862 4.145 0 7.612 2.808 8.682 6.613.442 1.612 2.231 1.561 2.231 1.561A2.608 2.608 0 0 0 85 49.904l-.071-14.076zm-6.603-3.511H65.312a1.996 1.996 0 0 1-1.989-1.99V20.143c0-1.098.894-1.99 1.989-1.99h4.365c2.483 0 4.117 2.009 4.63 2.978l5.065 9.434c.521.962.053 1.752-1.046 1.752z"/>
            <!--eslint-disable-next-line -->
            <path fill="white" d="M4.127 4.208c-.596 0-1.083.389-1.083.987v44.709c0 .597.488 1.086 1.086 1.086h1.004c.005-.047.123-.271.133-.317 1.267-5.562 6.323-9.597 12.022-9.597a12.356 12.356 0 0 1 11.912 9.137c.151.734.681.777.785.777h21.111c.596 0 1.083-.487 1.083-1.084V5.293c0-.598-.485-1.085-1.083-1.085H4.127z"/>
          </svg>
        </div>
        <svg class="wheels" width="85" height="15" viewBox="0 0 85 15">
          <circle fill="#AAD500" cx="17.289" cy="8.413" r="6.587"/>
          <circle fill="#AAD500" cx="71.48" cy="8.412" r="6.586"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  name: 'LoadingTruck',
};
</script>

<style lang="scss" scoped>
.wrapper-load {
  position: relative;
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(255,255,255,0.8);
    overflow: hidden;
    font-family: 'Open Sans', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    .loop-wrapper {
      align-items: center;
      position: absolute;
      width: 400px;
      height: 110px;
      overflow: hidden;
      border-bottom: 2px solid #AAD500;
    }
    .rock {
      margin-top: -17%;
      height: 3%;
      width: 2%;
      bottom: 0;
      border-radius: 20px;
      position: absolute;
      background: #AAD500;
    }
    .logo {
      width: 48px;
      color: #AAD500;
      position: absolute;
      margin-left: 19px;
      margin-top: 26px;
      font-size: 8px;
    }
    .truck, .wheels {
      transition: all ease;
      width: 120px;
      margin-right: -60px;
      bottom: 0px;
      right: 50%;
      position: absolute;
    }
    .truck {
      background: no-repeat;
      background-size: contain;
      height: 60px;
      margin-bottom: 15px;
      .surfer {
        position: absolute;
        margin-left: 76px;
        z-index: 2;
        top: -25px;
      }
    }
    .truck:before {
      content: "";
      position: absolute;
      width: 30px;
      box-shadow:
        -40px 28px 0 1.5px #AAD500,
        -45px 18px 0 1.5px #AAD500;
    }
    .wheels {
      background: no-repeat;
      height: 19px;
      margin-bottom: 0;
    }
    .rock  { animation: rock 4s   -0.530s linear infinite; }
    .truck  { animation: truck 4s   0.080s ease infinite; }
    .truck:before { animation: wind 1.5s   0.000s ease infinite; }
    @keyframes rock {
      0%   { right: -200px; }
      100% { right: 2000px; }
    }
    @keyframes truck {
      0%   { }
      6%   { transform: translateY(0px); }
      7%   { transform: translateY(-6px); }
      9%   { transform: translateY(0px); }
      10%   { transform: translateY(-1px); }
      11%   { transform: translateY(0px); }
      100%   { }
    }
    @keyframes wind {
      0%   {  }
      50%   { transform: translateY(4px) }
      100%   { }
    }
  }
}
</style>
